module.exports = __webpack_public_path__ + "static/img/finallogo.5ce1a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/finallogo.png
// module id = ROnY
// module chunks = 1